// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectedValue__base__2-wRv","isUppercased":"SelectedValue__isUppercased__2Ioku","label":"SelectedValue__label__zr97i"};